var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 3.58172 12.4183 0 8.00001 0C3.58173 0 0 3.58172 0 8C0 12.4183 3.58173 16 8.00001 16C12.4183 16 16 12.4183 16 8Z",
    fill: "#FF0209"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.396 11.5435C11.1577 11.5694 10.9137 11.5739 10.6799 11.5733C8.85566 11.5716 7.03147 11.5699 5.20785 11.5688C4.63389 11.5688 4.00877 11.5503 3.56524 11.1854C3.06548 10.7734 2.96149 10.0589 2.92101 9.4124C2.86479 8.52644 2.8603 7.63768 2.90639 6.75116C2.93169 6.26434 2.9761 5.76571 3.18578 5.32498C3.33644 5.00849 3.58772 4.72404 3.90927 4.57451C4.28311 4.4008 4.67436 4.43172 5.07687 4.43116C6.0404 4.43003 7.00393 4.42947 7.96746 4.42835C8.96922 4.42722 9.97154 4.42666 10.9733 4.42554C11.4466 4.42554 11.9548 4.43509 12.341 4.70886C12.8396 5.06189 12.9751 5.73367 13.0375 6.34136C13.1528 7.4606 13.1545 8.59165 13.042 9.7109C12.9954 10.1724 12.9178 10.6604 12.6137 11.0106C12.3123 11.358 11.8654 11.4918 11.3966 11.543L11.396 11.5435Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63141 7.99995L6.91284 6.43042V9.56948L9.63141 7.99995Z",
    fill: "#FF0209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeCircle);
export default __webpack_public_path__ + "static/media/youtube-circle.d554c136a0429daaac8d7cb5ad756e67.svg";
export { ForwardRef as ReactComponent };